var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "booking_config_pane" }, [
    _c("div", { staticClass: "config-content" }, [
      _c(
        "div",
        { staticClass: "left-panel" },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "门店信息" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.displayedStores,
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                        size: "mini",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "storeId", label: "门店编号" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "storeName", label: "门店名称" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "storeAddress", label: "门店地址" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.activityName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "activityName", $$v)
                      },
                      expression: "form.activityName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "预定日期" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.form.bookingDateList,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bookingDateList", $$v)
                      },
                      expression: "form.bookingDateList",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "就餐日期" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.form.diningDateList,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "diningDateList", $$v)
                      },
                      expression: "form.diningDateList",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "午餐数量" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, precision: 0 },
                    model: {
                      value: _vm.form.lunchQty,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "lunchQty", $$v)
                      },
                      expression: "form.lunchQty",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "晚餐数量" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, precision: 0 },
                    model: {
                      value: _vm.form.dinnerQty,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dinnerQty", $$v)
                      },
                      expression: "form.dinnerQty",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "关联商品：", prop: "checkedGoodsList" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70%" },
                      attrs: {
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        placeholder: "请搜索选项推荐商品",
                        "remote-method": _vm.searchGoods,
                        loading: _vm.searchGoodsLoading,
                        "value-key": "fnId",
                      },
                      model: {
                        value: _vm.checkedGoods,
                        callback: function ($$v) {
                          _vm.checkedGoods = $$v
                        },
                        expression: "checkedGoods",
                      },
                    },
                    _vm._l(_vm.goodsList, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.fnId,
                          attrs: { label: item.goodsName, value: item },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.goodsName) +
                                    "(" +
                                    _vm._s(item.unitName) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.goodsCode))]),
                            ]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "text" }, on: { click: _vm.addGoods } },
                    [_vm._v("\n            添加\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      key: _vm.goodsTableKey,
                      staticStyle: { width: "70%", "margin-top": "10px" },
                      attrs: { border: "", data: _vm.form.checkedGoodsList },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "goodsName", label: "商品名称" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "unitName", label: "商品规格" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "goodsPrice", label: "商品价格(￥)" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "activityPrice", label: "销售价格(￥)" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input-number", {
                                  attrs: {
                                    min: 0,
                                    precision: 0,
                                    size: "small",
                                  },
                                  model: {
                                    value: scope.row.activityPrice,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "activityPrice", $$v)
                                    },
                                    expression: "scope.row.activityPrice",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeGoods(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  移除\n                "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否启用：", prop: "markForEnable" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.form.markForEnable,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "markForEnable", $$v)
                        },
                        expression: "form.markForEnable",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: false } }, [
                        _vm._v("\n              无效\n            "),
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: true } }, [
                        _vm._v("\n              有效\n            "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v("\n            提交\n          ")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.goBack } }, [
                    _vm._v("\n            返回\n          "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isEditMode && _vm.bookingList.length === 0
        ? _c(
            "div",
            { staticClass: "right-panel" },
            [
              _c(
                "el-card",
                { staticClass: "store-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("i", { staticClass: "el-icon-office-building" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("门店选择")]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: { click: _vm.selectAllStores },
                        },
                        [
                          _c("i", { staticClass: "el-icon-check" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.isAllSelected ? "取消全选" : "全选") +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c(
                      "div",
                      { staticClass: "search-box" },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入关键字进行筛选",
                            "prefix-icon": "el-icon-search",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.storeSearchText,
                            callback: function ($$v) {
                              _vm.storeSearchText = $$v
                            },
                            expression: "storeSearchText",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "store-tree" },
                      [
                        _c("el-tree", {
                          ref: "storeTree",
                          attrs: {
                            data: _vm.storeTreeData,
                            "show-checkbox": "",
                            "node-key": "id",
                            "default-expanded-keys": _vm.expandedKeys,
                            "default-checked-keys": _vm.checkedKeys,
                            props: _vm.defaultProps,
                            "filter-node-method": _vm.filterNode,
                          },
                          on: { "check-change": _vm.handleStoreCheck },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }